// extracted by mini-css-extract-plugin
export default {"container":"container-GJU_g","vertical":"vertical-NSV7v","horizontal":"horizontal-ERHrQ"};